import { AxiosError } from "axios";
import useAxiosError from "./useAxiosError";

const useError = (
  errors: (AxiosError|undefined)[],
  options?: any[],
) => {
  for (let i = 0; i < errors.length; i++) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useAxiosError(errors[i], options?.at(i));
  }
};

export default useError;